import { TextField } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoaderComp from "../../LoaderComp";
import {
  addError,
  addToken,
  addToUser,
  getCallId,
  getToken,
} from "../../Redux/UserSlice";
import {
  backendApi,
  callPlayBot,
  CompleteApi,
  fetchCustomApiWithToken,
  LiveCallApi
} from "../../services/service";
import "./VerificationPage.css";

const Otp = ({ setPage, languageContent, userData }) => {
  const dispatch = useDispatch();
  const token = useSelector(getToken);
  const call_id = useSelector(getCallId);
  const [errorIncorrectPin, setErrorIncorrectPin] = useState(false);
  const [sendOtpAgain, setSendOtpAgain] = useState(false);
  const [OTP, setOTP] = useState("");
  // const [loader, setLoader] = useState(false);
  const [dis, setDis] = useState(false);
  const [liveCallResponse, setLiveCallResponse] = useState(false)

  let nudge30SecondTimer = useRef(null)
  let nudge60SecondTimer = useRef(null)
  const template_send_otp = () => {
    callPlayBot(call_id, "send_otp")
      .then((res) => console.log(res.data))
      .catch((e) => console.log(e.message));
  };
  const template_nudge = () => {
    callPlayBot(call_id, "no_otp_nudge")
      .then((res) => console.log(res.data))
      .catch((e) => console.log(e.message));
  }
  const liveCallApi = async (call_id) => {
    await LiveCallApi(call_id)
    .then((res) => {
      console.log(res.data);
      if (res.data === false) {
        if(userData.flow_type && userData.flow_type.toLowerCase() === "hdfc"){
          setPage('callDisconnected')
        }
      }
      setLiveCallResponse(true)
    })
    .catch((e) => {
      setPage("sorryPage");
    });
  }
  useEffect(() => {
    liveCallApi(call_id)
    template_send_otp();
    nudge30SecondTimer = setTimeout(() => template_nudge(), 30000);
    nudge60SecondTimer = setTimeout(() => template_nudge(), 60000);
    const id = setTimeout(() => {
      setDisableVerify(true);
    }, 60000);
    return () => {
      clearTimeout(id);
      clearNudgeTimers();
    }
  }, []);

  const clearNudgeTimers = () => {
      clearTimeout(nudge30SecondTimer)
      clearTimeout(nudge60SecondTimer)
  }

  const handleInput = (e) => {
    clearNudgeTimers()

    setOTP(e.target.value);
  };

  const handleResendButton = async () => {
    // setDisableVerify(false)

    await backendApi(call_id, "resendOtp", "click")
      .then((res) => console.log(res.data))
      .catch((e) => {
        dispatch(addError(e.message));
        setPage("sorryPage");
      });
    await callPlayBot(call_id, "resend_otp")
      .then((res) => console.log(res.data))
      .catch((e) => {
        dispatch(addError(e.message));
        setPage("sorryPage");
      });
    await fetchCustomApiWithToken(
      call_id,
      "GET",
      `resendOTP/${call_id}`,
      {},
      token
    )
      .then((res) => {
        if (res.data.responseCode === 200) {
          setSendOtpAgain(true);
          setDisableVerify(false);
          setTimeout(() => {
            setDisableVerify(true);
          }, 60000);
        } else {
          dispatch(addError(res.data));
          setPage("sorryPage");
        }
      })
      .catch((e) => {
        dispatch(addError(e.message));
        setPage("sorryPage");
      });
  };
  const [count, setCount] = useState(0);
  const handleVerifyButton = async () => {
    clearNudgeTimers()
    if (OTP === "") {
      setErrorIncorrectPin(true);
      callPlayBot(call_id, "incorrect_otp")
        .then((res) => {
          console.log(res.data);
        })
        .catch((e) => console.log(e.message));
      return;
    }
    console.log(dis);

    setDis(true);
    setCount(count + 1);

    await fetchCustomApiWithToken(
      call_id,
      "POST",
      `verify/${call_id}`,
      {otp: OTP},
      token
    )
      .then((res) => {
        if (res.data.token) {
          dispatch(addToUser(res.data.data));
          dispatch(addToken(res.data.token));
          backendApi(call_id, "otp_verification", "success")
            .then((res) => {
              console.log(res.data);
              setDis(false);
              setPage("personalDetails");
            })
            .catch((e) => {
              dispatch(addError(e.message));
              setPage("sorryPage");
            });
        } else {
          backendApi(call_id, "otp_verification", "failure")
            .then((res) => console.log(res.data))
            .catch((e) => {
              setPage("sorryPage");
            });
          setDis(false);
          if (count > 1) {
            CompleteApi(call_id, "incorrect_details")
              .then((res) => {
                console.log(res.data);
                setPage("sorryPageAttempt");
              })
              .catch((e) => {
                console.log(e.data);
                setPage("sorryPageAttempt");
              });
            return;
          }
          setErrorIncorrectPin(true);
          callPlayBot(call_id, "incorrect_otp")
            .then((res) => console.log(res.data))
            .catch((e) => {
              setPage("sorryPage");
            });
        }
        console.log(res.data.data);
      })
      .catch((e) => {
        dispatch(addError(e.message));
        setPage("sorryPage");
      });
    // .finally(setDis(false));
  };
  const [disableVerify, setDisableVerify] = useState(false);

  return (
    liveCallResponse ?
    <>
      <div className="heading">
        <img src="./immigration.png" className="imageImmigration" alt="Img" />
        <p>{languageContent.verification_page.verification_title}</p>
      </div>
      <hr></hr>
      <p>{languageContent.verification_page.otp_title}</p>
      {/* <input
        value={OTP}
        onChange={handleInput}
        type="tel"
        className="myInput"
        placeholder={languageContent.verification_page.otp_placeHolder}
        maxLength="6"
      /> */}
      <TextField
        fullWidth
        value={OTP}
        onChange={handleInput}
        style={{ marginBottom: "1rem" }}
        placeholder={languageContent.verification_page.otp_placeHolder}
        autoComplete={"off"}
        // name="msisdn"
        type="tel"
        // onChange={handleInput}
        maxLength="6"
        // inputProps={{ maxLength: 10 }}
      />
      <div style={{ display: "flex", justifyContent: "space-around" }}>
        {disableVerify && (
          <button className="backButton" onClick={handleResendButton}>
            {languageContent.buttons.resend}
          </button>
        )}
        <button
          className={dis ? "disableButton" : "myButton"}
          onClick={handleVerifyButton}
        >
          {languageContent.buttons.verify}
        </button>
      </div>
      {dis && <LoaderComp />}
      {errorIncorrectPin && (
        <p>{languageContent.verification_page.incorrectMsg}</p>
      )}
      {sendOtpAgain && <p>{languageContent.verification_page.sendOtpAgain}</p>}
    </> :
    <LoaderComp />
  );
};

export default Otp;
